<template>
    <div class="marquee-container" :style="`background-color: ${backgroundColor};color: ${color};border-bottom: 1px solid #FFE69C;`">
        <p class="marquee-text">{{ text }}</p>
    </div>
</template>
  
<script>
import anime from 'animejs';

export default {
    name: "Marquee",
    props: {
        text: String,
        loop: Boolean,
        translateX: Array,
        easing: String,
        backgroundColor: String,
        color: String
    },
    data() {
        return {
            // isPaused: false, // Trạng thái dừng của hiệu ứng
            speed: 0
        };
    },
    created() {
        this.calculateSpeed();
    },
    mounted() {
        this.$nextTick(() => {
            this.createMarqueeAnimation();
        });
    },
    methods: {
        calculateSpeed() {
            const w = window.innerWidth;
            if (w <= 375) {
                this.speed = 18000;
            } else if (w <= 480) {
                this.speed = 16000;
            } else if (w <= 768) {
                this.speed = 14000;
            } else if (w <= 1024) {
                this.speed = 12000;
            } else {
                this.speed = 30000;
            }
        },
        createMarqueeAnimation() {
            const textElement = this.$el && this.$el.querySelector('.marquee-text');
            if (!textElement || !this.text) return;
            const textWidth = textElement.offsetWidth;
            const container = textElement.parentElement;
            const containerWidth = (container && container.offsetWidth) || window.innerWidth;
            const ratio = Math.max(textWidth / containerWidth, 1);
            const minDuration = 8000;
            const duration = Math.max(ratio * this.speed, minDuration);

            // Dùng pixel: bắt đầu với text vừa ở mép phải (thấy chữ ngay), kết thúc khi ra mép trái
            const startX = containerWidth;
            const endX = -textWidth;

            var animation = anime({
                targets: textElement,
                translateX: [startX, endX],
                duration: duration,
                loop: this.loop,
                easing: this.easing,
            });

            textElement.addEventListener('mouseenter', () => {
                animation.pause();
            });

            textElement.addEventListener('mouseleave', () => {
                animation.play();
            });
        },
    },
};
</script>
  
<style>
.marquee-container {
    color: white;
    width: 100%;
    padding: 6px 0;
    font-weight: 600;
    overflow: hidden;
    min-height: 28px;
    line-height: 1.4;
}

.marquee-text {
    display: inline-block;
    white-space: nowrap;
    margin: 0;
    padding-right: 2em;
    will-change: transform;
}
</style>